import { Button, Modal } from 'enable-ui';

import { MODAL_KEY } from 'modules/auth/core/modal-key';
import { LearnerProfileForm } from 'modules/learners/component/LearnerProfileForm';
import { useLearnerFormController } from 'modules/learners/core/controller/learner-form';

import { CreateButton, LearnerModal } from '../styles/member';

export const CreateLearnModal = () => {
  const {
    firstName,
    lastName,
    nickname,
    name,
    gender,
    phone,
    email,
    yearOfBirth,
    dayOfBirth,
    monthOfBirth,
    height,
    weight,
    password,
    handleChange,
    handleSubmit,
    handleChangePhone,
    handleChangeMeasurement,
    onChangeGender,
    disabled,
    emailStatus,
    handleChangeDate,
    isAccount,
    onChangeYear,
    onChangeMonths,
    searchSelectMonth,
    searchSelectYear,
    onChangeSearchMonths,
    onChangeSearchYears,
  } = useLearnerFormController();

  return (
    <LearnerModal>
      <Modal
        modalKey={MODAL_KEY.CREATE_LEARNER}
        footer={
          <div
            style={{
              padding: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
            }}
          >
            <CreateButton>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                onClick={() => handleSubmit()}
                disabled={disabled}
              >
                Create and add to class
              </Button>
            </CreateButton>
          </div>
        }
        header="Create Client"
      >
        <LearnerProfileForm
          handleChange={handleChange}
          handleChangePhone={handleChangePhone}
          onChangeGender={onChangeGender}
          handleChangeMeasurement={handleChangeMeasurement}
          emailStatus={emailStatus}
          nickname={nickname}
          name={name}
          gender={gender}
          phone={phone}
          yearOfBirth={yearOfBirth}
          dayOfBirth={dayOfBirth}
          monthOfBirth={monthOfBirth}
          email={email ?? ''}
          height={height}
          weight={weight}
          firstName={firstName}
          lastName={lastName}
          handleChangeDate={handleChangeDate}
          isAccount={isAccount}
          password={password}
          onChangeYears={onChangeYear}
          onChangeMonths={onChangeMonths}
          searchSelectMonth={searchSelectMonth.value}
          searchSelectYear={searchSelectYear.value}
          onChangeSearchMonths={onChangeSearchMonths}
          onChangeSearchYears={onChangeSearchYears}
          // disabledMeasurement
        />
      </Modal>
    </LearnerModal>
  );
};
